import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { UserService } from "@app/services/user.service";
import { Observable, from } from "rxjs";
import { tap, map } from "rxjs/operators";

@Injectable({
  providedIn: "root", // Ensuring singleton service and enabling tree shaking
})
export class CatalogBuilderGuardService {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return from(this.userService.hasAccess("catalog-builder")).pipe(
      tap((hasAccess) => {
        if (!hasAccess) {
          this.router.navigate(["/products"]); // Redirect to products page if no access
        }
      }),
      map((hasAccess) => hasAccess) // Emit the access status as the observable result
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state); // Reuse canActivate logic for child routes
  }
}
